// Public-site configuration. Values below are placeholders until the
// founder's real ones exist — swap them here, nowhere else.

// Tally waitlist form, live 2026-07-19 (form id EkrlK4, created via the
// Tally API). Interim: kb/10's 2026-07-18 plan was to wait for GoHighLevel's
// native form instead, but the founder wanted the beta waitlist running now
// rather than wait on GHL setup — revisit once GHL exists (kb/10).
export const WAITLIST_URL = "https://tally.so/r/EkrlK4";

// hello@kovrie.com — live 2026-07-18, forwards via Cloudflare Email Routing
// to the founder's real inbox. Confirmed, not a placeholder.
export const CONTACT_EMAIL = "hello@kovrie.com";
